module.exports = __webpack_public_path__ + "static/mark_4-92b29e7004f6b00733c445c46ad5af6b.png";